import { Avatar } from "@mui/material";

import { Button } from "./ui/button";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";
import { ListUserInvitationsResponse } from "@/store/pomeriumApi";

type OrganizationInvitesProps = {
  invites: ListUserInvitationsResponse | undefined;
  openClusterOrgModal: () => void;
  setShowInvites: (value: boolean) => void;
  accepted: (inviteID: string, invitedBy: string) => void;
  rejected: (inviteID: string, invitedBy: string) => void;
};

export default function OrganizationInvites({
  invites,
  accepted,
  rejected,
  setShowInvites,
  openClusterOrgModal,
}: OrganizationInvitesProps) {
  return (
    <Card>
      <CardHeader>
        <h2 className="text-sm text-sidebar-primary">
          Welcome to Pomerium Zero!
        </h2>
        <CardTitle>Organization Invites</CardTitle>
        <CardDescription>
          You have been invited by existing Pomerium organizations. You can
          accept or reject them or skip them for now and set up a personal
          deployment.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Inviter</TableHead>
              <TableHead>Invite Date</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {!invites?.length ? (
              <TableRow>
                <TableCell>No remaining invites</TableCell>
              </TableRow>
            ) : (
              invites.map((invite) => (
                <TableRow key={invite.id}>
                  <TableCell>{invite.organization.name}</TableCell>
                  <TableCell>
                    <span className="flex items-center gap-2 py-auto">
                      <Avatar
                        src={invite.invitedBy?.photoUrl || ""}
                        variant="circular"
                        sx={{ width: 24, height: 24 }}
                      />
                      {invite.invitedBy.displayName || invite.invitedBy.email}
                    </span>
                  </TableCell>
                  <TableCell>
                    {new Date(invite.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell className="flex items-center gap-2">
                    <Button
                      variant="default"
                      onClick={() =>
                        accepted(
                          invite.id as string,
                          invite?.invitedBy?.displayName as string,
                        )
                      }
                    >
                      Accept
                    </Button>
                    <Button
                      variant="destructive"
                      onClick={() =>
                        rejected(
                          invite.id as string,
                          invite?.invitedBy?.displayName as string,
                        )
                      }
                    >
                      Reject
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
      <CardFooter className="justify-end">
        <CardAction className="grid grid-flow-col gap-2">
          <Button variant="secondary" onClick={() => setShowInvites(false)}>
            Setup Personal Deployment
          </Button>
          <Button
            variant="default"
            disabled={invites && invites.length > 0}
            onClick={openClusterOrgModal}
          >
            Go to Dashboard
          </Button>
        </CardAction>
      </CardFooter>
    </Card>
  );
}
